import { OccupationType } from 'api/types/entity';
import { yesOrNotSelectValidation } from 'helpers/yesOrNo';
import {
  ObjectSchema,
  object,
  priceAndCurrencyOptional,
  TypedForm,
} from 'libs/form';
import { PriceFieldValue } from 'libs/form/fields/PriceAndCurrencyField';
import { BiographyFormType } from 'modules/client/common/forms/biographyForm';
import { Maybe } from 'types/maybe';
import { NullablePartial } from 'types/nullablePartial';
import { SelectType } from 'types/selectType';
import { YesOrNoType } from 'types/yesOrNo';

export type BaseDebtsOptionalPrice = Maybe<NullablePartial<PriceFieldValue>>;

export interface BaseDebtsFormType {
  debts: {
    taxes?: BaseDebtsOptionalPrice;
    fees?: BaseDebtsOptionalPrice;
    penalties?: BaseDebtsOptionalPrice;
    finesForViolation?: BaseDebtsOptionalPrice;
    bankruptcyProceedings?: Maybe<SelectType<YesOrNoType>>;
    delaysOrNonFulfillmentOfObligations?: Maybe<SelectType<YesOrNoType>>;
  };
}

const isEntrepreneur = (values?: BiographyFormType) =>
  values?.biography?.occupation?.value === OccupationType.entrepreneur;

export const getBaseDebtsItemSchema = (
  requireEntrepreneurFields?: boolean
): ObjectSchema<BaseDebtsFormType['debts']> =>
  object({
    taxes: priceAndCurrencyOptional().nullable(),
    fees: priceAndCurrencyOptional().nullable(),
    penalties: priceAndCurrencyOptional().nullable(),
    finesForViolation: priceAndCurrencyOptional().nullable(),

    bankruptcyProceedings: yesOrNotSelectValidation
      .default(undefined)
      .when((_, schema, opt) => {
        const shouldBeRequired =
          requireEntrepreneurFields || isEntrepreneur(opt.context);
        if (shouldBeRequired) {
          return schema.default(null).required();
        }
        return schema;
      })
      .nullable(),

    delaysOrNonFulfillmentOfObligations: yesOrNotSelectValidation
      .default(undefined)
      .when((_, schema, opt) => {
        const shouldBeRequired =
          requireEntrepreneurFields || isEntrepreneur(opt.context);
        if (shouldBeRequired) {
          return schema.default(null).required();
        }
        return schema;
      })
      .nullable(),
  });

export const getBaseDebtsSchema = (
  requireEntrepreneurFields?: boolean
): ObjectSchema<BaseDebtsFormType> =>
  object({
    debts: getBaseDebtsItemSchema(requireEntrepreneurFields),
  });

export const { Field, Form, useFormContext, Submit } =
  TypedForm<BaseDebtsFormType>();
